/**
 * Marketing Cookie Consent State
 * 
 * Lightweight consent manager stored in localStorage.
 * Values: 'granted' | 'denied' | null (not yet decided).
 * 
 * This module is provider-agnostic so it can gate any marketing tracker.
 */

const CONSENT_KEY = 'prepframe_marketing_consent';

export type ConsentValue = 'granted' | 'denied' | null;

/** Read current marketing consent value */
export function getMarketingConsent(): ConsentValue {
  if (typeof window === 'undefined') return null;
  const val = localStorage.getItem(CONSENT_KEY);
  if (val === 'granted' || val === 'denied') return val;
  return null;
}

/** Persist marketing consent choice */
export function setMarketingConsent(value: 'granted' | 'denied'): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(CONSENT_KEY, value);
}

/** Check if user has made any consent decision */
export function hasConsentDecision(): boolean {
  return getMarketingConsent() !== null;
}
